// Navigate to the habit tracker. On web, /app/ is the Godot web export served
// as static files outside the React router (see public/serve.json), so it
// needs a full-page navigation — Godot boots and adopts localStorage['token'].
// Native builds (Electron/Capacitor) keep the React tracker at the /app route.
export function goToApp(navigate, options = {}) {
  if (process.env.REACT_APP_IS_NATIVE === 'true') {
    navigate('/app', options);
    return;
  }
  if (options.replace) {
    window.location.replace('/app/');
  } else {
    window.location.assign('/app/');
  }
}
